/**
 * time-zone — strefa czasowa aplikacji, wspólna dla API i panelu.
 *
 * Tenant ani firma nie mają dziś ustawienia strefy czasowej (kolumny w rodzaju `tenants.timezone`
 * nie ma), a rynek jest polski — wszędzie, gdzie kod zamienia moment w czasie na datę dla człowieka
 * (termin w mailu, numeracja, okna dobowe, data na wydruku KSeF), liczymy w jednej strefie.
 * Własna strefa per tenant / firma to osobna decyzja produktowa (miałaby zastąpić tę stałą
 * w miejscach użycia).
 */

/** Strefa czasowa aplikacji (IANA) — `Europe/Warsaw`; powód i zakres użycia → opis pliku. */
export const APP_TIME_ZONE = 'Europe/Warsaw';
